function InlineLogo({ className }: { className?: string }) {
  return (
    <div>
      <p className={className}>BFE</p>
    </div>
  );
}

export default InlineLogo;
